var _rect, _path, _path2, _path3, _path4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#F4FFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.481 167.5C239.481 175.136 234.539 182.124 226.391 187.229C218.251 192.329 206.973 195.5 194.49 195.5C182.007 195.5 170.73 192.329 162.589 187.229C154.442 182.124 149.5 175.136 149.5 167.5C149.5 159.864 154.442 152.876 162.589 147.771C170.73 142.671 182.007 139.5 194.49 139.5C206.973 139.5 218.251 142.671 226.391 147.771C234.539 152.876 239.481 159.864 239.481 167.5Z",
    stroke: "#546E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.519 167.5C228.519 182.878 213.378 195.5 194.49 195.5C175.603 195.5 160.461 182.878 160.461 167.5C160.461 152.122 175.603 139.5 194.49 139.5C213.378 139.5 228.519 152.122 228.519 167.5Z",
    stroke: "#546E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.365 167.5C215.365 175.272 213.002 182.29 209.205 187.353C205.408 192.415 200.2 195.5 194.49 195.5C188.78 195.5 183.573 192.415 179.776 187.353C175.979 182.29 173.615 175.272 173.615 167.5C173.615 159.728 175.979 152.71 179.776 147.647C183.573 142.585 188.78 139.5 194.49 139.5C200.2 139.5 205.408 142.585 209.205 147.647C213.002 152.71 215.365 159.728 215.365 167.5Z",
    stroke: "#546E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.307 167.5C203.307 175.332 202.269 182.402 200.603 187.497C199.77 190.047 198.788 192.075 197.721 193.455C196.65 194.841 195.554 195.5 194.49 195.5C193.427 195.5 192.331 194.841 191.259 193.455C190.193 192.075 189.211 190.047 188.377 187.497C186.711 182.402 185.673 175.332 185.673 167.5C185.673 159.668 186.711 152.598 188.377 147.503C189.211 144.953 190.193 142.925 191.259 141.545C192.331 140.159 193.427 139.5 194.49 139.5C195.554 139.5 196.65 140.159 197.721 141.545C198.788 142.925 199.77 144.953 200.603 147.503C202.269 152.598 203.307 159.668 203.307 167.5Z",
    stroke: "#546E6B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 194.442,
    y1: 139,
    x2: 194.442,
    y2: 196,
    stroke: "#546E6B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 149,
    y1: 168.096,
    x2: 239.981,
    y2: 168.096,
    stroke: "#546E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/Card2.ed34f8ae255ea1407a845dc033b9c123.svg";
export { ForwardRef as ReactComponent };